import baseRoute from '../baseRoute';

export type * from './viewModel';

type RouteDefinition = `${typeof baseRoute}/${number | ':purchaseOrderId'}`;

export const ROUTE: RouteDefinition = `${baseRoute}/:purchaseOrderId`;

export const URL = (purchaseOrderId: number): RouteDefinition => `${baseRoute}/${purchaseOrderId}`;
